<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="election-period">
  <div class="p-30" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Période de vote</p>
        <p class="no-margin dark-gray text-sm">
          Dates et heures d'ouverture et de fermeture du scrutin
        </p>
      </div>
    </div>

  </div>

  <div class="p-30">
    <!-- <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/calendar-blue-icon.svg" alt="">
      <h3 class="dark-blue bold text-md no-margin">Premier tour</h3>
    </div> -->
    <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px;" class="mb-30">
      <div>
        <p class="dark-blue no-margin">Ouverture du vote <span class="red">*</span></p>
        <div class="mb-10">
          <input type="date" name="first_open" id="first_open" class="text-md dark-blue pap-input w-full"
            [(ngModel)]="fROpeningString" [min]="minDate" (ngModelChange)="onPeriodChange()">
        </div>
        <p class="dark-blue no-margin">Horaire d'ouverture <span class="red">*</span></p>
        <div>
          <input type="time" name="first_open_time" id="first_open_time" class="text-md dark-blue pap-input w-full"
          [(ngModel)]="fROpeningTime">
        </div>
      </div>

      <div>
        <p class="dark-blue no-margin">Clôture du vote <span class="red">*</span></p>
        <div class="mb-10">
          <input type="date" name="first_close" id="first_close" class="text-md dark-blue pap-input w-full"
            [(ngModel)]="fRClosingString" [min]="minFirstClosingDate" (ngModelChange)="onPeriodChange()">
        </div>
        <p class="dark-blue no-margin">Horaire de clôture <span class="red">*</span></p>
        <div>
          <input type="time" name="first_close_time" id="first_close_time" class="text-md dark-blue pap-input w-full"
          [(ngModel)]="fRClosingTime">
        </div>
      </div>
    </div>

    <!-- <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/calendar-blue-icon.svg" alt="">
      <h3 class="dark-blue bold text-md no-margin">Second tour</h3>
    </div>

    <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px;">
      <div>
        <p class="dark-blue no-margin">Ouverture du vote <span class="red">*</span></p>
        <div class="mb-10">
          <input type="date" name="second_open" id="second_open" class="text-md dark-blue pap-input w-full"
            [(ngModel)]="sROpeningString" [min]="minSecondOpeningDate" (ngModelChange)="onPeriodChange()">
        </div>
        <p class="dark-blue no-margin">Horaire d'ouverture <span class="red">*</span></p>
        <div>
          <input type="time" name="second_open_time" id="second_open_time" class="text-md dark-blue pap-input w-full"
          [(ngModel)]="sROpeningTime">
        </div>
      </div>

      <div>
        <p class="dark-blue no-margin">Clôture du vote <span class="red">*</span></p>
        <div class="mb-10">
          <input type="date" name="second_close" id="second_close" class="text-md dark-blue pap-input w-full"
            [(ngModel)]="sRClosingString" [min]="minSecondClosingDate" (ngModelChange)="onPeriodChange()">
        </div>
        <p class="dark-blue no-margin">Horaire de clôture <span class="red">*</span></p>
        <div>
          <input type="time" name="second_close_time" id="second_close_time" class="text-md dark-blue pap-input w-full"
            [(ngModel)]="sRClosingTime" (ngModelChange)="onPeriodChange()">
        </div>
      </div>
    </div> -->

  </div>
</div>